export default (namespace) => ({
  [`${namespace}.propertyArea`]: 'que tiene',
});
